import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { SmallBusinessRepository } from '@/application/smallBusiness/domain/SmallBusinessRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

export class SubmitApplicationUseCase implements UseCase<SmallBusinessApplication, SfApiResponse<SmallBusinessApplication>> {

  private repository: SmallBusinessRepository;

  public constructor (repository: SmallBusinessRepository) {
    this.repository = repository;
  }

  public async run (application: SmallBusinessApplication): Promise<SfApiResponse<SmallBusinessApplication>> {
    return await this.repository.submitSmallBusinessApplication(application);
  }

}
